// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// tslint:disable-next-line: only-arrow-functions
function getBackendUrl(): string {
  const pathname = window.location.pathname;
  const path = pathname.endsWith('/') ? pathname : pathname + '/';
  return `${window.location.origin}${path}api`;
}

export const environment = {
  production: false,
  backendURL: getBackendUrl(),
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as
 *  `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode
 * because it will have a negative impact
 * on performance if an error is thrown.
 */
// Import 'zone.js/dist/zone-error'
// Included with Angular CLI.
